// hooks/order/useOrderDetail.js
import { useState, useCallback } from "react";
import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "@/utils/order/constants";
import { buildApiUrl } from "@/utils/order/helpers";

export function useOrderDetail() {
    const [orderDetail, setOrderDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Lấy thông tin chi tiết đơn hàng
    const fetchOrderDetail = useCallback(async (orderId) => {
        if (!orderId) return;

        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem("authToken");
            
            // Sử dụng hàm tiện ích buildApiUrl
            const apiUrl = `${API_BASE_URL}${buildApiUrl(API_ENDPOINTS.DETAIL, { id: orderId })}`;

            const response = await axios.get(
                apiUrl,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.isSuccess) {
                setOrderDetail(response.data.data);
                console.log("Order detail received:", response.data.data);
            } else {
                setError(response.data.error?.message || "order.errorLoading");
            }
        } catch (err) {
            setError("order.errorLoading");
            console.error("Error fetching order detail:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        orderDetail,
        loading,
        error,
        fetchOrderDetail,
    };
}
